/*
  This is the old gallery component. 
  It is used to display the old gallery layout for backward compatibility. 
  This is depricated and no longer supported in editor from July 2025.
  We can retire this component in the future (May be by July 2026).
*/
import React, { useState } from 'react';
import RGL, { WidthProvider } from 'react-grid-layout';
import { ContentState } from 'draft-js';
import { Button, Col, Row, Popover, Divider } from 'antd';
import PropTypes from 'prop-types';
import { LoadingOutlined } from '@ant-design/icons';
import helpers from 'helpers';
import utils from 'utils/utils';
import ComponentWrapper from '../ComponentWrapper/ComponentWrapper';

const ReactGridLayout = WidthProvider(RGL);

const LegacyGalleryComponent = ({ block, blockProps }) => {
  const [converted, setConverted] = useState(false);
  const [toolOpen, setToolOpen] = useState(false);

  const contentState = ContentState.createFromBlockArray([block]);

  const getGalleryValue = () => {
    const ent = block.getEntityAt(0);
    const entity = contentState.getEntity(ent);

    const {
      data: { data },
    } = entity;
    return data;
  };

  const images = getGalleryValue();

  const onRemove = () => blockProps && blockProps.onRemove(block.getKey());

  const handleSwitch = () => {
    // convert old gallery to new gallery
    const data = { config: { layout: 'columns' }, data: [] };

    data.data = images.map((item) => ({
      i: utils.getRandomString(),
      image: item.image,
    }));

    setConverted(true);
    const entityKey = block.getEntityAt(0);
    if (entityKey) {
      contentState.replaceEntityData(entityKey, { ...data });
      blockProps.update(block);
      blockProps.onFinishEdit(block.getKey());
    }
    setToolOpen(false);
  };

  const handleBlur = () => blockProps.handleEditComponent(false);

  const getGrid = (images) => {
    if (images.length && images[0]?.x === undefined) {
      return null;
    }

    return (
      <ReactGridLayout
        className="layout"
        height={150}
        width={1200}
        rowHeight={30}
        margin={[2, 2]}
        preventCollision={false}
        isDraggable={false}
        isResizable={false}>
        {images.map((galleryImg) => (
          <div
            key={galleryImg.i}
            style={{
              position: 'initial',
              backgroundImage: `url("${helpers.formatS3Link(galleryImg?.image)}")`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '50% 50%',
            }}
            data-grid={{
              i: galleryImg.i,
              x: galleryImg.x,
              y: galleryImg.y,
              w: galleryImg.w,
              h: galleryImg.h,
            }}
          />
        ))}
      </ReactGridLayout>
    );
  };

  return (
    <ComponentWrapper
      showDrag
      showActionButtons
      showEdit={false}
      showDelete
      isDraggable
      sectionName={blockProps.sectionName}
      setDraggingElement={blockProps.setDraggingElement}
      blockKey={block.getKey()}
      remove={onRemove}
      onBlur={handleBlur}
      componentType={'Gallery'}
      handleEditComponent={blockProps.handleEditComponent}
      setDropDisabled={blockProps.setDropDisabled}
      toolbar={
        converted ? null : (
          <Col>
            <Popover
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              content={
                <Col className="table-delete-popover">
                  <h3 className="ant-popover-title">Switch to the new revamped gallery</h3>
                  <Divider />
                  <p className="text-center">
                    Switching to new gallery will remove the old layout and add a new one.
                  </p>
                  <Row className="button-wrapper">
                    <Button className="medium-btn secondary-btn" onClick={handleSwitch}>
                      Switch
                    </Button>
                    <Button className="medium-btn grey-btn" onClick={() => setToolOpen(false)}>
                      Cancel
                    </Button>
                  </Row>
                </Col>
              }
              placement="bottomRight"
              overlayClassName="Prosprich-editor-components-popover"
              trigger="click"
              visible={toolOpen === 'delete'}
              onVisibleChange={(visible) => setToolOpen(visible ? 'delete' : false)}>
              <span>Switch to new gallery</span>
            </Popover>
          </Col>
        )
      }>
      <div className="gallery-container">
        <div className="gallery-image-container legacy">
          {converted ? (
            <div className="loading">
              <LoadingOutlined />
            </div>
          ) : (
            !!images.length && getGrid(images)
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
};

LegacyGalleryComponent.propTypes = {
  block: PropTypes.instanceOf(Object).isRequired,
  blockProps: PropTypes.instanceOf(Object).isRequired,
};

export default LegacyGalleryComponent;
